import { useApolloClient } from "@apollo/client";
import { ModalOpenButton } from "@msys/ui";
import { Edit as EditIcon } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import React from "react";
import { CategoriesSearchModal } from "../../categories/CategoriesSearchModal.js";
import { useModifyOrganisationProfile__ServicesMutation } from "../Organisations.generated.js";

interface Props {
  slug: string;
  categories: string[];
}

export const ModifyOrganisationProfileCategoriesButton: React.FC<Props> = ({
  slug,
  categories,
}) => {
  const client = useApolloClient();
  const [modifyProfile] = useModifyOrganisationProfile__ServicesMutation({
    client,
  });

  return (
    <ModalOpenButton
      Modal={CategoriesSearchModal}
      modalProps={{
        initialSelectedCategoryIds: categories,
        handleSelectCategories: async (categories, handleClose) => {
          await modifyProfile({
            variables: {
              input: { slug, categories: categories.map(c => c.id) },
            },
          });
          handleClose();
        },
        handleClearCategories: async handleClose => {
          await modifyProfile({
            variables: {
              input: { slug, categories: [] },
            },
          });
          handleClose();
        },
      }}
    >
      <IconButton color="primary" size="small">
        <EditIcon />
      </IconButton>
    </ModalOpenButton>
  );
};
